// <head> metadata for ContactPage (https://www.dbos.dev/contact).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Contact Us | DBOS',
    },
    {
      name: 'description',
      content: 'Reach out to DBOS and our team will reply as soon as possible.',
    },
    {
      property: 'og:title',
      content: 'Contact Us | DBOS',
    },
    {
      property: 'og:description',
      content: 'Reach out to DBOS and our team will reply as soon as possible.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Contact Us | DBOS',
    },
    {
      name: 'twitter:description',
      content: 'Reach out to DBOS and our team will reply as soon as possible.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/675883fe7419fd4747ef5ae3_DBOS-Website-OG.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/contact',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
